import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../config/supabase'

const ResetPassword: React.FC = () => {
  const navigate = useNavigate()
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState<string>('')
  const [error, setError] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const [updating, setUpdating] = useState<boolean>(false)

  useEffect(() => {
    let isMounted = true
    const init = async () => {
      try {
        // When the user clicks the email link, Supabase sends a type=recovery hash
        // Ensure the session is established so we can call updateUser to set a new password
        const { data: sessionData } = await supabase.auth.getSession()
        if (!sessionData?.session) {
          // Try to parse the URL hash and exchange it for a session
          await supabase.auth.exchangeCodeForSession(window.location.href)
        }
        if (isMounted) setLoading(false)
      } catch (e) {
        if (!isMounted) return
        setError('This reset link is invalid or expired. Please request a new one.')
        setLoading(false)
      }
    }
    init()
    return () => { isMounted = false }
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setMessage('')
    if (!newPassword || newPassword.length < 8) {
      setError('Password must be at least 8 characters.')
      return
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.')
      return
    }
    setUpdating(true)
    try {
      const { error } = await supabase.auth.updateUser({ password: newPassword })
      if (error) {
        setError(error.message || 'Failed to update password.')
        return
      }
      setMessage('Password updated. Redirecting...')
      setTimeout(() => navigate('/ev', { replace: true }), 1200)
    } catch (e: any) {
      setError(e?.message || 'Unexpected error while updating password.')
    } finally {
      setUpdating(false)
    }
  }

  if (loading) {
    return (
      <div className="container" style={{ maxWidth: 480, marginTop: 40 }}>
        <div>Loading reset session…</div>
      </div>
    )
  }

  return (
    <div className="container" style={{ maxWidth: 480, marginTop: 40 }}>
      <h2>Reset Password</h2>
      {error && <div className="error-message" style={{ marginTop: 12 }}>{error}</div>}
      {message && <div className="success-message" style={{ marginTop: 12 }}>{message}</div>}
      <form onSubmit={handleSubmit} style={{ marginTop: 16 }}>
        <div className="form-group">
          <label htmlFor="new-password">New password</label>
          <input
            id="new-password"
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            placeholder="Enter a new password"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirm-password">Confirm new password</label>
          <input
            id="confirm-password"
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            placeholder="Re-enter the new password"
            required
          />
        </div>
        <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
          <button type="submit" className="btn btn-primary" disabled={updating}>
            {updating ? 'Updating…' : 'Set New Password'}
          </button>
        </div>
      </form>
    </div>
  )
}

export default ResetPassword


